import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faTrash,
  faPencil,
  faXmark,
  faBars,
  faGripVertical,
  faArrowUp,
  faArrowDown,
  faDownload,
  faUser,
  faCode,
  faLink,
  faSun,
  faMoon,
  faDesktop,
  faCheck,
  faEnvelope,
  faPhone,
  faComments,
  faGlobe,
  faBuilding,
  faNewspaper,
  faSpinner,
  faFileAlt,
  faChartBar,
  faRobot,
  faShoppingCart,
  faServer,
  faBullhorn,
  faSearch,
  faFolder,
  faRefresh,
  faExternalLink,
  faTabletAlt,
  faMobileAlt,
  faPlus,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faRocket,
  faExpand,
  faArrowUpRightFromSquare,
  faRightFromBracket,
  faGraduationCap,
  faCircle,
  faEllipsis,
  faWandMagicSparkles,
  faPaperPlane,
  faBrain,
  faBriefcase,
  faWrench,
  faShare,
} from "@fortawesome/free-solid-svg-icons";
import {
  faLinkedin,
  faGithub,
  faInstagram,
  faXTwitter,
  faDribbble,
  faBehance,
  faMedium,
  faYoutube,
  faTiktok,
  faPinterest,
  faTelegram,
  faDiscord,
  faSlack,
  faWhatsapp,
  faFacebook,
} from "@fortawesome/free-brands-svg-icons";
import { cn } from "@/lib/utils";

// Map old Material/generic icon names to Font Awesome icons
const iconMap: Record<string, IconDefinition> = {
  // Actions
  delete: faTrash,
  edit: faPencil,
  close: faXmark,
  menu: faBars,
  drag_handle: faGripVertical,
  grip_vertical: faGripVertical,
  arrow_upward: faArrowUp,
  arrow_downward: faArrowDown,
  download: faDownload,
  refresh: faRefresh,
  "external-link": faExternalLink,
  add: faPlus,
  check: faCheck,
  open_in_new: faArrowUpRightFromSquare,
  open_in_full: faExpand,
  logout: faRightFromBracket,
  expand: faExpand,

  // Navigation
  chevron_left: faChevronLeft,
  chevron_right: faChevronRight,
  chevron_down: faChevronDown,

  // UI/Theme
  light_mode: faSun,
  dark_mode: faMoon,
  computer: faDesktop,
  monitor: faDesktop,
  tablet: faTabletAlt,
  smartphone: faMobileAlt,
  panel_left: faBars,

  // Profile/Contact
  person: faUser,
  email: faEnvelope,
  phone: faPhone,
  chat: faComments,
  language: faGlobe,
  link: faLink,

  // Social - Brand icons (proper icons for each platform)
  linkedin: faLinkedin,
  github: faGithub,
  instagram: faInstagram,
  twitter: faXTwitter,
  x: faXTwitter,
  alternate_email: faXTwitter,
  dribbble: faDribbble,
  behance: faBehance,
  medium: faMedium,
  youtube: faYoutube,
  tiktok: faTiktok,
  pinterest: faPinterest,
  telegram: faTelegram,
  discord: faDiscord,
  slack: faSlack,
  whatsapp: faWhatsapp,
  facebook: faFacebook,

  // Fallback social mappings from Material names
  photo_camera: faInstagram,
  palette: faDribbble,
  brush: faBehance,
  thumb_up: faFacebook,
  business: faBuilding,
  article: faNewspaper,
  play_circle: faYoutube,
  music_note: faTiktok,
  push_pin: faPinterest,
  send: faTelegram,
  forum: faDiscord,
  tag: faSlack,

  // Skills/Categories
  code: faCode,
  analytics: faChartBar,
  smart_toy: faRobot,
  shopping_cart: faShoppingCart,
  dns: faServer,
  campaign: faBullhorn,
  
  // Additional actions
  sparkles: faWandMagicSparkles,
  loader: faSpinner,
  paper_plane: faPaperPlane,
  search: faSearch,
  folder: faFolder,
  rocket_launch: faRocket,
  school: faGraduationCap,

  // Files/Documents
  description: faFileAlt,
  progress_activity: faSpinner,

  // Additional UI elements
  circle: faCircle,
  more_horizontal: faEllipsis,

  // Missing icons that were referenced but not defined
  psychology: faBrain,
  work: faBriefcase,
  construction: faWrench,
  share: faShare,
  mail: faEnvelope,
};

interface IconProps {
  name: string;
  size?: number;
  className?: string;
}

export const Icon = ({ name, size = 24, className }: IconProps) => {
  const icon = iconMap[name];

  if (!icon) {
    console.warn(`Icon "${name}" not found in icon map`);
    return null;
  }

  // Convert pixel size to rem (Font Awesome uses em/rem)
  const remSize = size / 16;

  return (
    <FontAwesomeIcon
      icon={icon}
      className={cn(className)}
      style={{ fontSize: `${remSize}rem`, width: `${remSize}rem`, height: `${remSize}rem` }}
    />
  );
};
